import React, { useEffect, useRef, useState } from "react";
import FormInput from "../../../../components/FormInput";
import FormSelect from "../../../../components/FormSelect";
import Button from "../../../../components/Button";
import { Option } from "../../../../types";
import { useFormikContext } from "formik";
import { getCitiesByStateId } from "../../../../services/customer/dropdown";
import { ENVIRONMENT, GUJARAT_STATE_ID } from "../../../../clientConfig";
// import {
//   getCookie,
//   getLatLong,
//   getStateAndCityFromLatLong,
// } from "../../../../utils";

interface SearchFormProps {
  stateList: Option[];
}

const SearchForm: React.FC<SearchFormProps> = ({ stateList }) => {
  const { values }: any = useFormikContext();

  const [cityList, setCityList] = useState([]);
  const cityListRef = useRef<Option[]>([]);

  const handleCityData = (city: any) => {
    const newCityList = city?.map((item: any) => ({
      value: item._id,
      label: item.name,
    }));
    cityListRef.current = newCityList;
    setCityList(newCityList);
  };

  useEffect(() => {
    if (values?.state?.value || (ENVIRONMENT !== "local" && GUJARAT_STATE_ID)) {
      getCitiesByStateId(
        values?.state?.value ?? GUJARAT_STATE_ID,
        handleCityData,
        { is_dropdown: 1 }
      );
    }
  }, [values?.state?.value]);

  // async function doGetLatLong() {
  //   let data = getCookie("coordinates");
  //   if (!data) {
  //     data = await getLatLong();
  //   }
  //   let address: any = {};

  //   if (data?.latitude && data?.longitude) {
  //     address = await getStateAndCityFromLatLong(
  //       data?.latitude,
  //       data?.longitude
  //     );
  //   }

  //   if (stateList?.length && address?.state) {
  //     const selectedState = stateList?.find(
  //       (state: Option) => state.label === address?.state
  //     );
  //     setFieldValue("state", selectedState);

  //     setTimeout(() => {
  //       const cities = cityListRef?.current || cityList;
  //       const selectedCity = cities?.find(
  //         (state: Option) => state.label === address?.city
  //       );
  //       setFieldValue("city", selectedCity);
  //     }, 1000);
  //   }

  //   null;
  // }

  // useEffect(() => {
  //   doGetLatLong();
  // }, [stateList]);

  return (
    <div className="grid lg:grid-cols-12 lg:divide-x divide-y lg:divide-y-0 divide-gray-300">
      <div
        className={`py-4 px-3 lg:py-2 lg:pr-4 col-span-12 ${ENVIRONMENT === "local" ? "lg:col-span-3" : "lg:col-span-4"}`}
      >
        <h2 className="input-label">Search</h2>
        <div className="mt-1">
          <FormInput
            name="searchQuery"
            placeholder="Project Name, Area, Property Type"
          />
        </div>
      </div>
      {ENVIRONMENT === "local" && (
        <div className="col-span-12 lg:col-span-3 px-3 lg:px-4 py-4 lg:py-2">
          <h2 className="input-label">State</h2>
          <FormSelect
            options={stateList}
            name="state"
            classNamePrefix="Savitar"
            placeholder="Select State"
          />
        </div>
      )}

      <div
        className={`py-4 px-3 lg:py-2 lg:pr-4 col-span-12 ${ENVIRONMENT === "local" ? "lg:col-span-3" : "lg:col-span-4"}`}
      >
        <h2 className="input-label">City</h2>
        <FormSelect
          name="city"
          options={cityList}
          classNamePrefix="Savitar"
          placeholder="Select City"
          disabled={cityList?.length === 0}
        />
      </div>
      <div
        className={`"py-4 px-3 lg:py-2 lg:pl-4 flex justify-center items-center col-span-12 ${ENVIRONMENT === "local" ? "lg:col-span-3" : "lg:col-span-4"}`}
      >
        <Button
          type="submit"
          className="mt-7 rounded-md"
          disabled={
            !(
              values?.city?.value ||
              values?.state?.value ||
              values?.searchQuery
            )
          }
        >
          Search
        </Button>
      </div>
    </div>
  );
};

export default SearchForm;
